import request from '@utils/request';
export function carPageList(data) {
  return request({
    url: '/hycaner/officialWebsiteCarPage/noAuth/front/ssh/carPageList',
    method: 'get',
    // noToken: true,
    params: data
  })
}

export function getOfficialWebsiteCarPageDetailList(data) {
  return request({
    url: '/hycaner/officialWebsiteCarPageDetail/noAuth/front/ssh/getOfficialWebsiteCarPageDetailList',
    method: 'get',
    // noToken: true,
    params: data
  })
}

export function carPageListEN(data) {
  return request({
    url: '/hycaner/officialWebsiteTab/noAuth/front/ssh/list',
    method: 'get',
    // noToken: true,
    params: data
  })
}